export default "__VITE_ASSET__0j4sHnez__"